module.exports = __webpack_public_path__ + "img/download.05aef75c.svg";